import { render, staticRenderFns } from "./my_point.vue?vue&type=template&id=fbc7fc5c&scoped=true&"
import script from "./my_point.vue?vue&type=script&lang=js&"
export * from "./my_point.vue?vue&type=script&lang=js&"
import style0 from "./my_point.vue?vue&type=style&index=0&id=fbc7fc5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc7fc5c",
  null
  
)

export default component.exports